import type { AppListenerApi } from "@src/store/rootState";
import { basicModSlice } from "@src/store/slices/experienceBuilder/basicMod/slice";
import { actions } from "@src/store/slices/experienceBuilder/common/actions";
import { getVariationDraft } from "@src/store/slices/experienceBuilder/common/selectors/getVariationDraft";
import { componentSlice } from "@src/store/slices/experienceBuilder/component/slice";
import type { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";

// The config panel edits a `draft` copy seeded once on open; Viv writes straight
// to committed `mods`. Re-seed the open draft from Viv's change so the panel
// doesn't show a stale value (and a later Apply can't clobber it); clear it if
// the drafted mod was removed. `applyDraft` clears its draft before committing,
// so it never reaches this.
export function reconcileDraftWithMods(
  api: AppListenerApi,
  changed: { set: EmbeddedMod[]; remove: string[] }
): void {
  const draft = getVariationDraft(api.getState());
  if (!draft) return;

  if (changed.remove.includes(draft.id)) {
    api.dispatch(actions.clearDraft());
    return;
  }

  const next = changed.set.find((mod) => mod.id === draft.id);
  if (!next) return;
  if (next.category === "component") {
    api.dispatch(componentSlice.actions._initDraft(next));
  } else {
    api.dispatch(basicModSlice.actions._initDraft(next));
  }
}
